import { createContext, ReactElement } from 'react';
import { IDatasetDetailsService, useDatasetDetailsService } from './datasetDetails.service';
import { IDatasetsDetailsStore } from './datasetsDetails.store';

interface IDatasetDetailsContext {
  service: IDatasetDetailsService;
  store: IDatasetsDetailsStore;
}

export const DatasetDetails = createContext<IDatasetDetailsContext>(undefined);

export const DatasetDetailsContextFactory = ({ children }: { children: React.ReactNode }): ReactElement => {
  const service = useDatasetDetailsService();
  const ctx: IDatasetDetailsContext = {
    service,
    store: service.store,
  };

  return <DatasetDetails.Provider value={ctx}>{children}</DatasetDetails.Provider>;
};
